export const DATE_TIME_FORMAT = "MMM d, yyyy 'at' h:mm a";
export const DATE_FORMAT = "MMM d, yyyy";

export const getTimestampFromDate = (date: string | null | undefined): number => {
  return date ? new Date(date).getTime() : 0;
};

export const compareDateStrings = (
  dateA: string | null | undefined,
  dateB: string | null | undefined,
): number => {
  return getTimestampFromDate(dateA) - getTimestampFromDate(dateB);
};

export const compareByNameWithDateFallback = (
  nameA: string | null | undefined,
  nameB: string | null | undefined,
  dateA: string | null | undefined,
  dateB: string | null | undefined,
): number => {
  const normalizedNameA = nameA?.trim();
  const normalizedNameB = nameB?.trim();

  if (normalizedNameA && normalizedNameB) {
    return normalizedNameA.localeCompare(normalizedNameB);
  }

  if (normalizedNameA || normalizedNameB) {
    return normalizedNameA ? -1 : 1;
  }

  return compareDateStrings(dateA, dateB);
};

export const sortByVersionDesc = <T extends { version: number }>(items: T[]): T[] => {
  return [...items].sort((a, b) => b.version - a.version);
};
